import React, { useState, useRef, useEffect } from "react";
import { FaChevronDown, FaSearch, FaCheck } from "react-icons/fa";
 
const CustomDropdown = ({
  options = [],
  value,
  onChange,
  placeholder = "Select option",
  searchable = true,
  iconMap = {}, // { value: <Icon /> }
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const wrapperRef = useRef(null);
  const dropdownRef = useRef(null);
 
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
 
  const selectedOption = options.find((o) => o.value === value);
 
  const filteredOptions = options.filter((o) =>
    o.label.toLowerCase().includes(search.toLowerCase())
  );
 
  return (
    <div ref={wrapperRef} className="relative w-full">
      {/* Trigger */}
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-4 py-3 bg-white border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 hover:border-gray-300 transition-colors"
      >
        <div className="flex items-center gap-2 text-gray-700 truncate">
          {selectedOption && iconMap[selectedOption.value]}
          <span className={selectedOption ? "truncate" : "text-gray-400 truncate"}>
            {selectedOption ? selectedOption.label : placeholder}
          </span>
        </div>
        <FaChevronDown
          className={`text-gray-500 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>
 
      {/* Dropdown - Fixed to use portal-like positioning */}
      {open && (
       <div
  ref={dropdownRef}
  className="absolute z-[9999] mt-2 w-full bg-white border border-gray-200 rounded-xl shadow-xl overflow-hidden"
>
 
          {searchable && (
            <div className="p-3 border-b border-gray-100">
              <div className="relative">
                <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                <input
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search..."
                  className="w-full pl-9 pr-3 py-2 text-sm bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  autoFocus
                />
              </div>
            </div>
          )}
 
          <div className="max-h-60 overflow-y-auto custom-scrollbar">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => {
                    onChange(option.value);
                    setOpen(false);
                    setSearch("");
                  }}
                  className={`w-full flex items-center justify-between px-4 py-3 text-sm hover:bg-gray-50 transition-colors ${
                    value === option.value ? "bg-blue-50" : ""
                  }`}
                >
                  <div className="flex items-center gap-2 text-gray-700">
                    {iconMap[option.value]}
                    <span>{option.label}</span>
                  </div>
                  {value === option.value && (
                    <FaCheck className="text-blue-500 text-sm" />
                  )}
                </button>
              ))
            ) : (
              <div className="px-4 py-6 text-center text-sm text-gray-500">
                No results found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
 
export default CustomDropdown;